/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Card_Preview_PlaceholderInputs */

const cs_templates_card_preview_placeholder = /** @type {(inputs: Templates_Card_Preview_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Náhled po otevření`)
};

const en_templates_card_preview_placeholder = /** @type {(inputs: Templates_Card_Preview_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview after open`)
};

/**
* | output |
* | --- |
* | "Preview after open" |
*
* @param {Templates_Card_Preview_PlaceholderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_card_preview_placeholder = /** @type {((inputs?: Templates_Card_Preview_PlaceholderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Card_Preview_PlaceholderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_card_preview_placeholder(inputs)
	return cs_templates_card_preview_placeholder(inputs)
});